import axios from 'axios';
import { isBrowser, isDev } from './env.js';
import baseInfo from '@stores/index.js';
import jsonp from 'jsonp';
import logger from '@server-utils/client-logger';

const baseUrl = `//${isDev ? 'dev.' : ''}cc.163.com`;
const apiBaseUrl = `//api.${isDev ? 'dev.' : ''}cc.163.com`;
const apiFaUrl = `//fa.${isDev ? 'dev.' : ''}cc.163.com`; // https://fa.cc.163.com/modules/kv-module/
const protocol = isBrowser ? '' : 'http:';

// let waitingJWT = false;

export const getBaseInfo = `http:${baseUrl}/zt/`;
export const getVideoApi = `${baseUrl}/zt/module/video`;
export const gameBookingInfoApi = `${baseUrl}/zt/module/book/match/info`;
export const jwtInfoApi = `${baseUrl}/user/jwt/info/`;
export const jwtApi = `${apiBaseUrl}/v1/jwt`;
export const followApi = `${apiBaseUrl}/v1/matchranklist/action`;
export const getStarsFollowInfoApi = `${baseUrl}/zt/module/star/follow/info`;
export const getProgrammeApi = `${baseUrl}/zt/module/calendar`;
export const getVotesApi = `${baseUrl}/zt/module/vote/tag/info`;
export const toVoteApi = `${baseUrl}/zt/module/vote/team`;
export const bookGameApi = `${baseUrl}/zt/module/book/match`;
export const getweblinkLoginInfo = `${baseUrl}/token/`;
export const getCidApi = `${apiBaseUrl}/v1/activitylives/anchor/lives`;
export const pinCodeInfo = `${protocol}${apiBaseUrl}/v1/mpincode/act_code`;
export const getRoomInfoApi = `${baseUrl}/api/`;
export const anchorRankApi = `${baseUrl}/zt/module/pkrank/anchor_rank`;
export const shouhuRankApi = `${baseUrl}/zt/module/pkrank/shouhu_rank`;
export const frontendKvApi = `${protocol}${apiFaUrl}/api/kv/all`; // 键值后台配置，https://fa.cc.163.com/modules/kv-module/
export const userLogBaseUrl = `${protocol}//userlog.${isDev ? 'dev.cc.163' : 'cc.netease'}.com`;

axios.interceptors.request.use(
    async function(config) {
        // config.url += 1;
        let newConfig = Object.assign({}, config);
        if (config.jwt) {
            if (!newConfig.headers) newConfig.headers = {};
            if (baseInfo.jwtToken) {
                newConfig.headers.Authentication = baseInfo.jwtToken;
            } else {
                const jwtToken = await getJWT();
                newConfig.headers.Authentication = jwtToken;
            }
        }
        newConfig.validateStatus = () => {
            return true;
        };
        return newConfig;
    },
    function(error) {
        const log = {
            ...error
        };
        if (!isBrowser) {
            log.type = 'gamematchmobilenode-http-log';
        }
        logger.info(log);
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    async function(response) {
        if (response.status === 401 && response.data.code === 'JWT_CLAIM_EXPIRED') {
            // 获取jwt认证token
            // getJWT().then(function () {
            //     if (typeof response.config.jwtCallBack === 'function') {
            //         response.config.jwtCallBack();
            //     }
            // });
            await getJWT();
            let newResponse = await axios.request(response.config);
            return newResponse;
        } else {
            return response;
        }
    },
    function(error) {
        const log = {
            ...error
        };
        if (!isBrowser) {
            log.type = 'gamematchmobilenode-http-log';
        }
        logger.info(log);
        return Promise.reject(error);
    }
);

export function getData(url, params = {}, configs = {}) {
    const log = {
        description: 'get api',
        url: url
    };
    if (!isBrowser) {
        log.type = 'gamematchmobilenode-http-log';
    }
    logger.info(log);
    return new Promise((resolve) => {
        axios
            .get(url, { params: params, ...configs })
            .then((res) => {
                if (res.data) {
                    resolve(res.data);
                }
            })
            .catch((err) => {
                logger.error({
                    description: `getapi failed ${(err + '').substr(0, 100)}`,
                    url: url,
                    statusCode: err.response?.status
                });
            });
    });
}
export function postData(url, params = {}, configs = {}) {
    const log = {
        description: 'get api',
        url: url
    };
    if (!isBrowser) {
        log.type = 'gamematchmobilenode-http-log';
    }
    logger.info(log);
    let formData = new FormData();
    for (let key in params) {
        formData.append(key, params[key]);
    }
    return new Promise((resolve) => {
        axios
            .post(url, formData, { ...configs })
            .then((res) => {
                if (res.data) {
                    resolve(res.data);
                }
            })
            .catch((err) => {
                logger.error({
                    description: `postapi failed ${(err + '').substr(0, 100)}`,
                    url: url,
                    statusCode: err.response?.status
                });
            });
    });
}

export function getDataByJsonp(url, options, cb) {
    const log = {
        description: 'jsonp api',
        url: url
    };
    if (!isBrowser) {
        log.type = 'gamematchmobilenode-http-log';
    }
    logger.info(log);
    jsonp(url, options, cb);
}

// function setCsrSafe() {
//     var cookieValue = '';
//     var arrStr = document.cookie.split('; ');
//     for (var i = 0; i < arrStr.length; i++) {
//         var temp = arrStr[i].split('=');
//         if (temp[0] == 'cccsrftoken') {
//             cookieValue = temp[1];
//             break;
//         }
//     }
//     return cookieValue;
// }

export function getJWT() {
    return new Promise(function(resolve, reject) {
        const JWTData = function() {
            axios
                .get(jwtInfoApi, {
                    withCredentials: true
                })
                .then((res) => {
                    JWTapi(res.data);
                });
        };
        const JWTapi = function(json) {
            axios
                .get(jwtApi, {
                    params: {
                        appid: json.appid,
                        uid: json.uid,
                        eid: json.eid,
                        timestamp: json.timestamp
                    },
                    headers: { Authentication: json.sign }
                })
                .then((res) => {
                    baseInfo.setData('jwtToken', res.data.data.jwt);
                    resolve(res.data.data.jwt);
                })
                .catch(() => {
                    reject();
                });
        };
        JWTData();
    });
}

/**
 * @description: 获取webLogin js地址
 * @return {string} webLogin js地址
 */
export function getWebLoginUrl() {
    const defaultVersion = '1.0.0';
    return getData(frontendKvApi)
        .then((data) => {
            return `//${isDev ? 'dev.cc.163.com' : 'cc.res.netease.com'}/act/webcc/webLogin/${data
                ?.data?.webLoginVersion || defaultVersion}/index.js`;
        })
        .catch(() => {
            return `//${
                isDev ? 'dev.cc.163.com' : 'cc.res.netease.com'
            }/act/webcc/webLogin/${defaultVersion}/index.js`;
        });
}

/**
 * @description 发送用户点击日志
 * @param {string} [info='']
 * @returns
 */
export async function sendUserLog(info = '') {
    return getData(userLogBaseUrl + `/query?type=web&data=${info}`);
}
